import React, { useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { LinkOutlined, ArrowRightOutlined, CheckCircleOutlined } from '@ant-design/icons';
import api from '../../services/api';
import SlugChooserModal from './SlugChooserModal';

const { Text } = Typography;

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';

// Card no dashboard convidando o jogador a reservar seu slug antes que os
// melhores acabem. Some depois de escolhido. Le do local storage cache
// pra nao re-mostrar toda vez.
export default function SlugChooserCard() {
  const [slug, setSlug] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('community_user') || 'null');
    if (user?.slug) { setSlug(user.slug); setLoading(false); return; }
    // Refresh do backend
    api.get('/community/players/profile').then(r => {
      setSlug(r.data.slug || null);
      // atualiza cache
      const u = JSON.parse(localStorage.getItem('community_user') || 'null');
      if (u) { u.slug = r.data.slug; localStorage.setItem('community_user', JSON.stringify(u)); }
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (slug) {
    // Ja escolheu — mostra confirmacao (empilha vertical em mobile pra URL
    // longa nao forcar scroll horizontal).
    return (
      <div style={{
        background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 12,
        padding: '10px 14px', marginBottom: 16, fontSize: 13,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <CheckCircleOutlined style={{ color: BRAND, flexShrink: 0 }} />
          <Text style={{ color: '#333' }}>Teu perfil público:</Text>
        </div>
        <a href={`/jogador/${slug}`} target="_blank" rel="noreferrer"
           style={{
             color: BRAND_DARK, fontFamily: 'monospace', fontWeight: 700,
             wordBreak: 'break-all', display: 'inline-block',
           }}>
          {window.location.host}/jogador/{slug}
        </a>
      </div>
    );
  }

  return (
    <>
      <div style={{
        background: `linear-gradient(135deg, ${BRAND_DARK} 0%, ${BRAND} 100%)`,
        borderRadius: 16, padding: 20, marginBottom: 16,
        color: '#fff', position: 'relative', overflow: 'hidden',
        boxShadow: '0 8px 24px rgba(37, 211, 102, 0.25)',
      }}>
        <div style={{
          position: 'absolute', top: -40, right: -40, width: 160, height: 160,
          borderRadius: '50%', background: '#fff', opacity: 0.1,
        }} />
        <div style={{ position: 'relative', display: 'flex', gap: 14, alignItems: 'center' }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12,
            background: 'rgba(255,255,255,0.2)',
            display: 'grid', placeItems: 'center', fontSize: 22,
            flexShrink: 0, backdropFilter: 'blur(6px)',
          }}>🔗</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 900, lineHeight: 1.2 }}>
              Escolha o link do teu perfil
            </div>
            <div style={{ fontSize: 12, opacity: 0.9, marginTop: 4, lineHeight: 1.4 }}>
              Agora você tem perfil público e compartilhável. Escolhe antes que os melhores acabem!
            </div>
          </div>
          <Button
            size="large"
            icon={<ArrowRightOutlined />}
            onClick={() => setModalOpen(true)}
            style={{
              background: '#fff', color: BRAND_DARK, fontWeight: 800,
              borderColor: '#fff', height: 40, borderRadius: 10,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)', flexShrink: 0,
            }}
          />
        </div>
      </div>

      <SlugChooserModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onDone={(newSlug) => {
          setSlug(newSlug);
          const u = JSON.parse(localStorage.getItem('community_user') || 'null');
          if (u) { u.slug = newSlug; localStorage.setItem('community_user', JSON.stringify(u)); }
        }}
      />
    </>
  );
}
